import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Text, Loader, Box, Stack, Center, Divider } from "@mantine/core";
import { Rizvoice } from "../stores/Rizvoice";
import GenericInvoiceQR from "./genericInvoiceQR";
import BasicHeader from "../cubbyComponents/dataDisplay/basicHeader";

const Paywall = observer(({ rizvoice }: { rizvoice: Rizvoice }) => {
  useEffect(() => {
    const message = "get-paywall-invoice";
    const data = {
      accountUuid: rizvoice.accountUUid,
    };
    console.log(
      "getting prove you are human invoice, this must always run AFTER rizvoice has been set as loaded!",
    );
    rizvoice.rizLife(message, data);
  }, []);

  return (
    <Stack>
      <Text>Apologies: We need to verify that you are a human.</Text>

      <Text mb="sm">
        Please pay the invoice below so we can provision a node for you.
      </Text>
      <Text mb="sm">
        Note: we are currently building the next version of Rizful Node. For
        this reason, we are conserving resources in the current runtime and have
        set an "unusually high" price to "prove you are human." We'd like to
        apologize for any inconvenience. If you're looking for a lower-cost
        node-in-the-cloud solution, we recommend Alby Cloud.
      </Text>
      <Divider />
      {rizvoice.paywallPayRequest ? (
        <GenericInvoiceQR
          modelInstance={rizvoice}
          invoiceString={rizvoice.paywallPayRequest}
          whatIsItFor={"Prove you are human"}
        />
      ) : (
        <Center mt="lg">
          <Loader size="xl" />
        </Center>
      )}
    </Stack>
  );
});

export default Paywall;
